export default "__VITE_ASSET__CPU80q6j__"